/** Le jour, court : « 12/8 ». Sous dix bâtons, un mois écrit en toutes lettres
 *  ne tiendrait pas, et l'année ne sert à rien sur dix journées. */
const jourCourt = (iso: string): string => {
    const [, m, j] = iso.split('-');
    return `${Number(j)}/${Number(m)}`;
};

/* Est-ce que ça progresse ?
 *
 * ── Pourquoi une suite et non deux nombres ──────────────────────────────────
 *
 * La ligne repliée porte déjà l'écart entre la période récente et la
 * précédente : deux points, donc une flèche. Une flèche ne distingue pas une
 * progression régulière d'un bon jour au milieu d'une stagnation, et c'est
 * pourtant la différence entre « continuez » et « ce n'était qu'un jour sans
 * vent ». La suite des journées se lit ; deux nombres se croient.
 *
 * ── Les couleurs sont celles de la jauge ────────────────────────────────────
 *
 * Vert au-dessus de soixante-dix, laiton au-dessus de soixante, brique en
 * dessous : exactement les seuils de la jauge de fiabilité de la ligne
 * repliée. Un même taux ne peut pas changer de couleur d'une figure à
 * l'autre — c'est ce qui rend la rangée lisible sans légende.
 */
export function ProgresClub({ history }: {
    history: { jour: string; shots: number; center: number }[];
}) {
    if (history.length < 2) return null;

    const points = history.map((h) => ({
        ...h,
        taux: h.shots > 0 ? (h.center * 100) / h.shots : 0,
    }));

    const teinte = (t: number): string => (t >= 70 ? 'var(--color-primary)'
        : t >= 60 ? 'var(--brass-ink)'
            : 'var(--brique-bord)');

    return (
        <figure className="m-0">
            <div className="flex h-20 items-stretch gap-1">
                {points.map((p, i) => (
                    <div key={p.jour} className="flex min-w-0 flex-1 flex-col justify-end gap-0.5">
                        {/* Le taux n'est écrit que sur le DERNIER bâton : c'est
                            celui qu'on vient chercher, et dix nombres alignés
                            sur des colonnes de trente pixels ne se lisent
                            plus. Les autres se comparent à l'œil, ce qui est
                            précisément ce qu'une rangée de bâtons sait faire. */}
                        <span className="text-center text-[10px] font-bold leading-none tabular-nums opacity-70">
                            {i === points.length - 1 ? `${Math.round(p.taux)}%` : ''}
                        </span>
                        <div className="w-full rounded-t-[3px]"
                            style={{
                                height: `${Math.max(3, p.taux)}%`,
                                background: teinte(p.taux),
                                opacity: i === points.length - 1 ? 1 : 0.55,
                            }} />
                    </div>
                ))}
            </div>
            {/* Une date SOUS CHAQUE bâton, et non aux deux bouts.
                Aux bouts, les dates se lisaient comme les bornes d'un axe
                continu : on croyait à six jours consécutifs. Or ces bâtons sont
                des JOURNÉES D'ENTRAÎNEMENT, espacées de ce qu'elles sont
                espacées — trois jours ici, trois semaines là. Chacune porte donc
                la sienne, et l'on voit du même coup si le progrès a demandé un
                mois ou une semaine.

                Neuf pixels et `min-w-0` sur les colonnes : à dix journées,
                chaque colonne fait trente pixels de large, ce qui tient tout
                juste — mesuré, pas supposé. */}
            <div className="mt-1 flex gap-1 text-[9px] opacity-55">
                {points.map((p) => (
                    <span key={p.jour}
                        className="min-w-0 flex-1 overflow-hidden text-center tabular-nums">
                        {jourCourt(p.jour)}
                    </span>
                ))}
            </div>
        </figure>
    );
}
